module.exports = __webpack_public_path__ + "static/media/19.2b0fc766.svg";